import React from "react";
import NavComponent from "../../components/Nav";
import MenuSection from "../../components/MenuSection";
import FooterComponent from "../../components/Footer";

export interface MenuComponentProps {
  menuPageData?: any; // TODO: refine type later
  error?: any;
  isLoading?: boolean;
}

export const MenuContentPiece: React.FC<MenuComponentProps> = ({
  menuPageData,
  error,
  isLoading,
}) => {
  const title = menuPageData?.title || "Menu";
  const subtitle = menuPageData?.subtitle || "Discover our selections";
  const tasteOfSoul = menuPageData?.tasteOfSoul;
  const southernComforts = menuPageData?.southernComforts;
  const soulLos = menuPageData?.soulLos;
  const lilSouljers = menuPageData?.lilSouljers;
  const endSouls = menuPageData?.endSouls;
  const soulMates = menuPageData?.soulMates;
  const sipsAndSwigs = menuPageData?.sipsAndSwigs;

  return (
    <div className="bg-sow-black min-h-screen px-4 sm:px-6 md:px-8 lg:px-12 pt-24 sm:pt-20">
      {isLoading && (
        <div className="flex items-center justify-center h-screen text-sow-white">
          <div className="animate-pulse text-center">
            <p className="text-lg font-semibold mb-2">Loading menu…</p>
            <p className="text-sm opacity-75">Fetching menu data</p>
          </div>
        </div>
      )}
      {!isLoading && error && (
        <div className="flex flex-col items-center justify-center h-screen text-center px-6">
          <h1 className="text-2xl font-bold text-red-400 mb-4">
            Unable to load menu
          </h1>
          <p className="text-sow-white/80 max-w-md">
            We hit a snag loading the menu. Please refresh or try again later.
          </p>
        </div>
      )}
      {!isLoading && !error && menuPageData && (
        <>
          {/* Fixed nav with responsive positioning */}
          <div className="sow-fixed-navigation fixed top-4 left-1/2 -translate-x-1/2 z-40 sm:top-6 sm:left-6 sm:translate-x-0 lg:top-8 lg:left-8">
            <NavComponent />
          </div>
          {/* Spacer to account for fixed nav height on mobile (hidden larger screens) */}
          <div className="block sm:hidden h-4" aria-hidden="true" />
          <header className="max-w-5xl mx-auto text-center">
            <div
              className="mx-auto mb-6 sm:mb-8 h-[3px] w-1/2 bg-gradient-to-r from-transparent via-sow-gold to-transparent"
              aria-hidden="true"
            />
            <h1 className="hammer text-transparent bg-clip-text bg-gradient-to-r from-sow-gold via-amber-300 to-sow-darkGold drop-shadow-[0_2px_6px_rgba(255,216,97,0.35)] tracking-wide leading-tight font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
              {title}
            </h1>
            <p className="mt-4 text-base sm:text-lg md:text-xl text-sow-white/90 max-w-2xl mx-auto font-normal">
              {subtitle}
            </p>
          </header>
          {(
            menuPageData.categories || [
              tasteOfSoul,
              southernComforts,
              soulLos,
              lilSouljers,
              endSouls,
              soulMates,
              sipsAndSwigs,
            ]
          )
            .filter((section: any) => section && section.visible !== false)
            .map((section: any, index: number) => (
              <MenuSection
                key={section.id || index}
                section={section}
                className="mt-12 sm:mt-16 md:mt-20"
              />
            ))}
          <FooterComponent
            imageUrl={menuPageData?.sowLogo}
            backgroundUrl={menuPageData?.bkgImg}
          />
        </>
      )}
    </div>
  );
};
